import React, { Suspense, Component, useEffect } from 'react';
import PropTypes from 'prop-types';
import Core from './core';
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import ErrorBoundary from '@/components/ErrorBoundary/ErrorBoundary';
import { SectionContainerFakes } from '@/components/Fakes';
import { navigateBasedOnEnvironment } from '@/utils/htmlUtils';
/**
 * App component.
 * @returns {object} App rendered.
 */

export const getModule = (myModules, key) => {
  const currentModule = myModules.find((module) => module.id === key);
  return (currentModule && currentModule.loader) || null;
};

const RedirectWithQuery = ({ redirect }) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    navigateBasedOnEnvironment(
      navigate,
      `${redirect}${location.search || ""}`
      ,
      true
    );
  }, [location.search, navigate, redirect]);

  return null;
};


class App extends Component {

  shouldComponentUpdate(){
    return false;
  }
  render(){
    const { urlLibrary, modulesLibrary, projectId } = this.props;
    return (
      <ErrorBoundary>
      <Core projectId={projectId}>
      <Suspense fallback={SectionContainerFakes.DEFAULT}>
        <Routes>
          {urlLibrary && urlLibrary.map((pageData) => {
            if (pageData) {
              const { loader, pathName, exact, redirect: redirectProp } = pageData;
              const path2Use = `${process.env.NEXT_PUBLIC_PROJECT_BASE_PATH}${pathName}`;
  
              if (redirectProp) {
                return (
                  <Route
                    key={`route-${path2Use}-redirect`}
                    path={path2Use}
                    element={<RedirectWithQuery redirect={redirectProp} />}
                  />
                )
              }
          
              const Component = getModule(modulesLibrary, loader);
                return (
                  <Route
                    exact={exact}
                    key={`route-${path2Use}}`}
                    path={path2Use}
                    Component={(params ) => {
                      return (<Component {...params } path={path2Use} urlLibrary={urlLibrary} />);
                    }}
                  />
                );
            }
  
            return null;
          })}
        </Routes>
      </Suspense>
      </Core>
      </ErrorBoundary>
    );
  }
}



App.propTypes = {
  projectId: PropTypes.string,
  urlLibrary: PropTypes.array.isRequired,
  modulesLibrary: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      loader: PropTypes.object.isRequired,
    })
  ).isRequired,
};

App.defaultProps = {};

export default App;
